module.exports = __webpack_public_path__ + "img/login-bg.b87227b5.jpg";